import { relativeTimestamp } from '@/Helpers.js';
import Model from '@/models/Model.js';
import ReadReceipt from '@/models/ReadReceipt.js';
import axios from '@/plugins/axios.js';

export default class CourseAnnouncement extends Model {
    static entity = 'course_announcements';

    static modelName = 'CourseAnnouncement';

    static fields() {
        return {
            id: this.attr(null),
            body: this.attr(null),
            safe_body: this.attr(null),
            course_id: this.attr(null),
            media: this.attr(null),
            title: this.attr(null),
            published_at: this.attr(null),
            alertType: this.string('Course Announcement'),
            important: this.attr(null),
            read: this.attr(null),

            ...super.fields(),

            creator: this.belongsTo('users', 'created_by'),
            course: this.belongsTo('courses', 'course_id'),
            read_receipts: this.morphMany('read_receipts', 'readable_id', 'readable_type_entity'),
        };
    }

    get marked_as_read() {
        const userId = Model.store().getters['Auth/userId'];

        if (userId === this.created_by) {
            return true;
        }

        const modelType = 'App\\Models\\CourseAnnouncement';

        return ReadReceipt.query()
            .where('readable_id', this.id)
            .where('readable_type', modelType)
            .where('user_id', userId)
            .exists();
    }

    get published_label() {
        return relativeTimestamp(this.timestamp('published_at'), { pastLabel: '', futureLabel: '', longFormat: false });
    }

    get router_link() {
        return {
            name: 'course-dashboard',
            params: { courseId: this.course_id },
        };
    }

    get backend_class() {
        return 'App\\Models\\CourseAnnouncement';
    }

    static async fetch(endpoint) {
        const { response } = await this.api().get(endpoint, {
            persistBy: 'create',
        });

        return response.data;
    }

    markAsRead() {
        return ReadReceipt.api().put('/api/mark-as-read', {
            readable_id: this.id,
            readable_type: 'App\\Models\\CourseAnnouncement',
        });
    }

    async markAsUnread() {
        const response = await axios.put('/api/mark-as-unread', {
            readable_id: this.id,
            readable_type: 'App\\Models\\CourseAnnouncement',
        });

        ReadReceipt.query()
            .where('readable_id', this.id)
            .where('readable_type', 'App\\Models\\CourseAnnouncement')
            .where('user_id', CourseAnnouncement.store().getters['Auth/userId'])
            .get()
            .forEach(readReceipt => readReceipt.$delete());

        return response;
    }

    get formatted_created_at() {
        return this.timestamp('created_at').format('MM/DD/YYYY - h:mm a');
    }
}
